import { FieldEditorProps } from './FieldEditorProps';
import '../styles/Editors.scoped.scss';
import SubscriptionTopicsSelect from 'Shared/components/SubscriptionTopicsSelect';
import Checkbox from 'Shared/components/Checkbox'

export const SubscriptionFieldEditor = ({ field, onChange }: FieldEditorProps) => {
  const organisationKinds = window.ENV.ORGANISATION_KINDS || []
  const organisationKindOptions = [
    { value: 'national', label: 'National' },
    ...organisationKinds
      .map((kind) => ({
        value: kind.external_type,
        label: kind.label || kind.name || kind.external_type
      }))
      .filter((option) => option.value)
  ]

  return <>
    <div className="field-editor-row">
      <label>Subscription Topic</label>
      <div className='field-editor-input'>
        <SubscriptionTopicsSelect
          documentPortalTarget={false}
          value={field.subscriptionTopics?.[0] ?? null}
          onChange={o => onChange({ subscriptionTopics: o?.value ? [o.value] : [] })}
        />
      </div>
    </div>

    <div className="field-editor-row">
      <label>Organisation Kind</label>
      <div className='field-editor-input'>
        <select
          className="source-selector"
          value={field.organisationKind ?? ''}
          onChange={(e) =>
            onChange({ organisationKind: e.target.value || null })
          }
        >
          <option value="">Select organisation kind</option>
          {organisationKindOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>

    <div className="field-editor-row">
      <div className='field-editor-input'>
        <Checkbox
          label="Allow Organiser's to Resubscribe"
          checked={field.source === 'resubscription'}
          onChange={(e) => onChange({ source: e.target.checked ? 'resubscription' : 'subscription' })}
        />
      </div>
    </div>
  </>
}
